import React, { useState, useEffect } from "react";
import styles from "./gananciasPage.module.css";
import { lotteryService, formatCurrency, formatShortDate } from "../../../../../services/api";

export default function GananciasPage({ onGoToRetiros }) {
  const [ganancias, setGanancias] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGanancias = async () => {
      try {
        const result = await lotteryService.getGanancias();
        if (result.ok) {
          setGanancias(result.data);
        } else {
          setError("Error al cargar las ganancias");
        }
      } catch (err) {
        setError("Error de conexión");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchGanancias();
  }, []);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner}></div>
        <p>Cargando ganancias...</p>
      </div>
    );
  }

  if (error) {
    return <div className={styles.error}>{error}</div>;
  }

  const { summary, recent_wins } = ganancias || {};

  return (
    <div className={styles.container}>
      {/* Resumen de ganancias */}
      <div className={styles.summaryCards}>
        <div className={styles.summaryCard}>
          <span className={styles.cardIcon}>🏆</span>
          <div className={styles.cardContent}>
            <p className={styles.cardLabel}>Total Ganado</p>
            <h2 className={styles.cardValue}>{formatCurrency(summary?.total_ganado || 0)}</h2>
          </div>
        </div>

        <div className={styles.summaryCard}>
          <span className={styles.cardIcon}>🎫</span>
          <div className={styles.cardContent}>
            <p className={styles.cardLabel}>Apuestas Realizadas</p>
            <h2 className={styles.cardValue}>{summary?.total_apostado || 0}</h2>
          </div>
        </div>
      </div>

      {onGoToRetiros ? (
        <div className={styles.withdrawRow}>
          <button type="button" className={styles.withdrawBtn} onClick={onGoToRetiros}>
            Retirar
          </button>
        </div>
      ) : null}

      {/* Últimas ganancias */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>Ganancias Recientes</h3>

        {recent_wins && recent_wins.length > 0 ? (
          <div className={styles.winsList}>
            {recent_wins.map((win, index) => (
              <div key={index} className={styles.winCard}>
                <div className={styles.winHeader}>
                  <span className={styles.winLottery}>{win.lottery_name}</span>
                  <span className={styles.winDate}>{formatShortDate(win.date)}</span>
                </div>
                <div className={styles.winDetails}>
                  <div className={styles.winNumbers}>
                    <span className={styles.label}>Número:</span>
                    <strong>{win.number}</strong>
                    <span className={styles.label}>Serie:</span>
                    <strong>{win.series}</strong>
                  </div>
                  <div className={styles.winAmount}>
                    <span className={styles.prizeLabel}>Premio</span>
                    <span className={styles.prizeValue}>{formatCurrency(win.amount)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.emptyState}>
            <span className={styles.emptyIcon}>🍀</span>
            <p className={styles.emptyText}>Aún no tienes ganancias registradas</p>
            <p className={styles.emptySubtext}>¡Sigue jugando y la suerte llegará!</p>
          </div>
        )}
      </div>

      {summary?.ultima_actualizacion && (
        <p className={styles.lastUpdate}>
          Última actualización: {new Date(summary.ultima_actualizacion).toLocaleString('es-CO')}
        </p>
      )}
    </div>
  );
}
